import { Checkout } from '@df/checkout/checkout.interfaces';

declare global {
    interface Window {
        Klarna?: {
            Payments?: Klarna.IPayments;
        };
    }
}

export namespace Klarna {
    export enum Scripts {
        JS_SDK = 'https://x.klarnacdn.net/kp/lib/v1/api.js'
    }

    export enum Methods {
        PAY_LATER = 'klarna_pay_later',
        PAY_OVER_TIME = 'klarna_pay_over_time'
    }

    export enum Endpoints {
        CONFIG = 'klarna/init'
    }

    export const KLARNA_NOT_AVAILABLE_ERROR = 'Method is not available';

    export interface IConfig {
        client_token: string | null;
        message?: string;
        success?: number;
        debug?: boolean;
        enabled?: boolean;
        b2b_enabled?: boolean;
        authorization_token?: string;
        available_methods?: IConfigAvailableMethod;
    }

    export interface IConfigAvailableMethod {
        type: string;
        component: string;
    }

    ////////////////////////////////////////////
    ///////////
    /////////// Payments
    ///////////
    ////////////////////////////////////////////

    export interface IPayments {
        init(options: IPaymentsInitOptions): void;
        load(options: IPaymentsLoadOptions, callback: (response: IPaymentsLoadResponse) => void): void;
        load(options: IPaymentsLoadOptions, data: IData, callback?: (response: IPaymentsLoadResponse) => void): void;
        authorize(options: IPaymentsAuthorizeOptions, data: IData, callback: (response: IPaymentsAuthorizeResponse) => void): void;
        authorize(options: IPaymentsAuthorizeOptions, callback: (response: IPaymentsAuthorizeResponse) => void): void;
        finalize(options: IPaymentsFinalizeOptions, data: IData, callback: (response: IPaymentsFinalizeResponse) => void): void;
        finalize(options: IPaymentsFinalizeOptions, callback: (response: IPaymentsFinalizeResponse) => void): void;
    }

    export interface IPaymentsInitOptions {
        client_token: string;
    }

    export interface IPaymentsLoadOptions {
        // html element or selector
        container: HTMLElement | string;
        payment_method_category: string;
        preferred_payment_method?: string;
    }

    export interface IPaymentsLoadResponse {
        show_form: boolean;
        error?: IPaymentsError;
    }

    export interface IPaymentsAuthorizeOptions extends IPaymentsFinalizeOptions {
        auto_finalize?: boolean;
    }

    export interface IPaymentsAuthorizeResponse extends IPaymentsFinalizeResponse {
        finalize_required: boolean;
    }

    export interface IPaymentsFinalizeOptions {
        payment_method_category: string;
    }

    export interface IPaymentsFinalizeResponse {
        authorization_token: string;
        show_form: boolean;
        approved: boolean;
        error?: IPaymentsError;
    }

    export interface IPaymentsError {
        invalid_fields?: string[];
    }

    export interface IData {
        purchase_country?: string;
        purchase_currency?: string;
        locale?: string;
        order_amount?: number;
        order_tax_amount?: number;
        order_lines?: IPaymentsOrderLineData[];
        billing_address?: IPaymentsAddress;
        shipping_address?: IPaymentsAddress;
        customer?: IPaymentsCustomerData;
    }

    export interface IPaymentsCustomerData {
        date_of_birth?: string;
        gender?: string;
    }

    export interface IPaymentsOrderLineData {
        type?: string;
        reference?: string;
        name?: string;
        quantity?: number;
        unit_price?: number;
        tax_rate?: number;
        total_amount?: number;
        total_discount_amount?: number;
        total_tax_amount?: number;
        product_url?: string;
        image_url?: string;
    }

    export interface IPaymentsAddress {
        given_name?: string;
        family_name?: string;
        street_address?: string;
        street_address2?: string;
        city?: string;
        postal_code?: string;
        country?: string;
        phone?: string;
        region?: string;
        email: string;
    }

    export interface IPaymentsSubmissionPaymentData extends Checkout.ISubmissionPaymentData {
        method: Methods;
        additional_data: IPaymentsSubmissionAdditionalPaymentData;
    }

    export interface IPaymentsSubmissionAdditionalPaymentData {
        authorization_token: string;
    }
}
